import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "content-panel step-four-panel",
  style: {"max-width":"1000px"}
}
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "panel-icon" }
const _hoisted_4 = { class: "panel-header-actions" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "panel-body" }
const _hoisted_8 = {
  key: 0,
  class: "confirmed-notice-banner"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "confirm-dialog-header" }
const _hoisted_11 = { class: "confirm-dialog-footer" }
const _hoisted_12 = { class: "confirm-dialog-header warning" }
const _hoisted_13 = { class: "confirm-dialog-footer" }

import { ref, computed, watch, nextTick, onMounted } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import TabSabokWage from '@/components/wage/TabSabokWage.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'StepFour',
  props: {
    stepCompleted: { type: Boolean },
    isConfirmed: { type: Boolean },
    isConfirming: { type: Boolean }
  },
  emits: ["confirm", "release"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

const isConfirmed = computed(() => !!props.isConfirmed);
const isConfirming = computed(() => !!props.isConfirming);

// TabSabokWage 참조
const tabSabokWageRef = ref<any>(null);

// 확정/해제 확인 다이얼로그 상태
const showConfirmDialog = ref(false);
const showReleaseDialog = ref(false);

// 반응성 트리거를 위한 카운터
const dataUpdateTrigger = ref(0);

// 확정 가능 여부를 체크하는 함수
const checkStepCompleted = () => {
  // props로 전달된 값이 있으면 우선 사용 (DB 확정 상태)
  if (props.stepCompleted) return true;
  
  // TabSabokWage의 데이터가 있는지 확인
  if (!tabSabokWageRef.value) {
    return false;
  }
  
  const staffData = tabSabokWageRef.value.staffData;
  const staffSettings = tabSabokWageRef.value.staffSettings || [];
  
  // 데이터가 없으면 false
  if (!staffData || staffData.length === 0) {
    return false;
  }
  
  // 저장된 직원이 1명 이상 있는지 확인 (empCode가 있는 직원)
  let validStaffCount = 0;
  
  for (let i = 0; i < staffData.length; i++) {
    const staff = staffData[i];
    
    // empCode가 없으면 아직 저장되지 않은 임시 데이터이므로 스킵
    if (!staff.empCode) {
      continue;
    }
    
    const settings = staffSettings[i];
    const deriveNumericValue = (value: any) => {
      if (typeof value === 'number') return value;
      if (value === null || value === undefined) return 0;
      return parseFloat(String(value).replace(/,/g, '')) || 0;
    };
    
    const timePaySource = settings?.timePay ?? staff.timePay;
    const workHoursSource = settings?.workHours ?? staff.workHours;
    
    // 시급과 근무시간 확인 (숫자로 변환하여 확인)
    const timePay = deriveNumericValue(timePaySource);
    const workHours = deriveNumericValue(workHoursSource);
    
    
    // 시급과 근무시간이 모두 0보다 크면 유효한 직원으로 카운트
    if (timePay > 0 && workHours > 0) {
      validStaffCount++;
    }
  }
  
  const isCompleted = validStaffCount > 0;
  
  return isCompleted;
};

// 확정 가능 여부 계산 (computed)
const stepCompleted = computed(() => {
  // 반응성 트리거 사용
  dataUpdateTrigger.value;
  return checkStepCompleted();
});

// 주기적으로 체크 (1초마다)
let checkInterval: any = null;

// 컴포넌트 마운트 시 주기적 체크 시작
watch(tabSabokWageRef, (newVal) => {
  if (newVal && !checkInterval) {
    // 초기 체크
    nextTick(() => {
      dataUpdateTrigger.value++;
    });
    
    // 5초 동안만 주기적으로 체크 (데이터 로드 대기)
    let count = 0;
    checkInterval = setInterval(() => {
      dataUpdateTrigger.value++;
      count++;
      
      // 10번 체크 후 중지 (10초)
      if (count >= 10) {
        clearInterval(checkInterval);
        checkInterval = null;
      }
    }, 1000);
  }
}, { immediate: true });

// 확정 버튼 클릭
const handleConfirm = () => {
  showConfirmDialog.value = true;
};

const proceedConfirm = async () => {
  showConfirmDialog.value = false;
  
  const user = store.state.user;
  if (!user || !user.m_sisul_code) {
    store.commit('showSnackbar', { text: '사용자 정보를 확인할 수 없습니다.', color: 'error' });
    return;
  }

  if (!tabSabokWageRef.value) {
    store.commit('showSnackbar', { text: '직원 데이터를 확인할 수 없습니다.', color: 'error' });
    return;
  }

  try {
    const searchParams = tabSabokWageRef.value.searchParams;
    const sisulCode = user.m_sisul_code;
    const lebYm = searchParams.lebYm;
    
    // hh_emp_sabok_work_info 테이블에서 저장된 임금대장 데이터 조회
    const workInfoResponse = await axios.get(`/api/calc/work-info/${sisulCode}/${lebYm}`, {
      withCredentials: true
    });
    
    if (!workInfoResponse.data.success || !workInfoResponse.data.data) {
      store.commit('showSnackbar', { 
        text: '저장된 급여 데이터가 없습니다. 먼저 급여 설정을 저장해주세요.', 
        color: 'warning' 
      });
      return;
    }
    
    const workInfoData = workInfoResponse.data.data;
    
    // 직종별 데이터 집계
    let yoboTotalCount = 0;
    let yoboTotalWageSum = 0;
    let yoboTotalEmployeeDeduction = 0;
    let yoboTotalCenterDeduction = 0;
    let yoboTotalNonTaxable = 0;
    let yoboTotalAge = 0;
    let yoboTotalAgeCount = 0;
    let yoboTotalSugaSum = 0;
    let yoboTotalCenterProfit = 0;
    let yoboTotalEmpSavings = 0;
    let yoboTotalCenterSavings = 0;
    
    let sabokTotalCount = 0;
    let sabokTotalWageSum = 0;
    let sabokTotalEmployeeDeduction = 0;
    let sabokTotalCenterDeduction = 0;
    let sabokTotalNonTaxable = 0;
    let sabokTotalAge = 0;
    let sabokTotalAgeCount = 0;
    let sabokTotalCenterProfit = 0;
    let sabokTotalEmpSavings = 0;
    let sabokTotalCenterSavings = 0;
    
    // 수급자 수 계산을 위해 요양보호사 데이터 조회
    const uniquePatients = new Set<string>();
    try {
      const yoboResponse = await axios.get('/api/calc/caregiver-member-join', {
        params: { sisulCode, lebYm },
        withCredentials: true
      });
      if (yoboResponse.data.success && yoboResponse.data.data) {
        yoboResponse.data.data.forEach((item: any) => {
          if (item.leb_patient_code) {
            uniquePatients.add(item.leb_patient_code);
          }
        });
      }
    } catch (e) {
      console.warn('수급자 수 조회 오류:', e);
    }
    
    // 저장된 데이터를 직종별로 분류하여 합산
    workInfoData.forEach((item: any) => {
      const empJob = item.emp_job || '';
      const isYobo = empJob === '요양보호사';
      
      // 나이 계산 (생년월일 기준)
      let age = 0;
      if (item.emp_birth) {
        const birthDate = new Date(item.emp_birth);
        const baseYear = parseInt(lebYm.substring(0, 4));
        const baseMonth = parseInt(lebYm.substring(4, 6));
        const baseDate = new Date(baseYear, baseMonth, 0);
        age = baseDate.getFullYear() - birthDate.getFullYear();
        if (baseDate.getMonth() < birthDate.getMonth() ||
          (baseDate.getMonth() === birthDate.getMonth() && baseDate.getDate() < birthDate.getDate())) {
          age--;
        }
      }
      
      if (isYobo) {
        // 요양보호사
        yoboTotalCount++;
        yoboTotalWageSum += Number(item.ewi_total_pay) || 0;
        yoboTotalEmployeeDeduction += Number(item.ewi_emp_total_deduction) || 0;
        yoboTotalCenterDeduction += Number(item.ewi_center_total_deduction) || 0;
        yoboTotalNonTaxable += Number(item.ewi_non_taxable_amount) || 0;
        yoboTotalSugaSum += Number(item.ewi_monthly_pay) || 0;
        yoboTotalCenterProfit += Number(item.ewi_center_profit) || 0;
        yoboTotalEmpSavings += Number(item.ewi_emp_tax_savings) || 0;
        yoboTotalCenterSavings += Number(item.ewi_center_tax_savings) || 0;
        if (age > 0) {
          yoboTotalAge += age;
          yoboTotalAgeCount++;
        }
      } else {
        // 사회복지사/센터장/사무 등
        sabokTotalCount++;
        sabokTotalWageSum += Number(item.ewi_total_pay) || 0;
        sabokTotalEmployeeDeduction += Number(item.ewi_emp_total_deduction) || 0;
        sabokTotalCenterDeduction += Number(item.ewi_center_total_deduction) || 0;
        sabokTotalNonTaxable += Number(item.ewi_non_taxable_amount) || 0;
        sabokTotalCenterProfit += Number(item.ewi_center_profit) || 0;
        sabokTotalEmpSavings += Number(item.ewi_emp_tax_savings) || 0;
        sabokTotalCenterSavings += Number(item.ewi_center_tax_savings) || 0;
        if (age > 0) {
          sabokTotalAge += age;
          sabokTotalAgeCount++;
        }
      }
    });
    
    const yoboAverageAge = yoboTotalAgeCount > 0 ? Math.round(yoboTotalAge / yoboTotalAgeCount) : 0;
    const sabokAverageAge = sabokTotalAgeCount > 0 ? Math.round(sabokTotalAge / sabokTotalAgeCount) : 0;
    const totalAgeCount = yoboTotalAgeCount + sabokTotalAgeCount;
    const totalAverageAge = totalAgeCount > 0 
      ? Math.round((yoboTotalAge + sabokTotalAge) / totalAgeCount) 
      : 0;

    // 마감 데이터 준비
    const magamData = [
      // 요양보호사 데이터
      {
        wm_sisul_code: sisulCode,
        wm_ym: lebYm,
        wm_job_type: '요양보호사',
        wm_count: yoboTotalCount,
        wm_wage_sum: yoboTotalWageSum,
        wm_emp_deduction: yoboTotalEmployeeDeduction,
        wm_center_deduction: yoboTotalCenterDeduction,
        wm_non_taxable: yoboTotalNonTaxable,
        wm_emp_savings: yoboTotalEmpSavings,
        wm_center_savings: yoboTotalCenterSavings,
        wm_center_profit: yoboTotalCenterProfit,
        wm_avg_age: yoboAverageAge,
        wm_suga_sum: yoboTotalSugaSum,
        wm_pacient_count: uniquePatients.size
      },
      // 사회복지사/센터장 데이터
      {
        wm_sisul_code: sisulCode,
        wm_ym: lebYm,
        wm_job_type: '사회복지사/센터장',
        wm_count: sabokTotalCount,
        wm_wage_sum: sabokTotalWageSum,
        wm_emp_deduction: sabokTotalEmployeeDeduction,
        wm_center_deduction: sabokTotalCenterDeduction,
        wm_non_taxable: sabokTotalNonTaxable,
        wm_emp_savings: sabokTotalEmpSavings,
        wm_center_savings: sabokTotalCenterSavings,
        wm_center_profit: sabokTotalCenterProfit,
        wm_avg_age: sabokAverageAge,
        wm_suga_sum: 0,
        wm_pacient_count: 0
      },
      // 전체 합계
      {
        wm_sisul_code: sisulCode,
        wm_ym: lebYm,
        wm_job_type: '전체합계',
        wm_count: yoboTotalCount + sabokTotalCount,
        wm_wage_sum: yoboTotalWageSum + sabokTotalWageSum,
        wm_emp_deduction: yoboTotalEmployeeDeduction + sabokTotalEmployeeDeduction,
        wm_center_deduction: yoboTotalCenterDeduction + sabokTotalCenterDeduction,
        wm_non_taxable: yoboTotalNonTaxable + sabokTotalNonTaxable,
        wm_emp_savings: yoboTotalEmpSavings + sabokTotalEmpSavings,
        wm_center_savings: yoboTotalCenterSavings + sabokTotalCenterSavings,
        wm_center_profit: yoboTotalCenterProfit + sabokTotalCenterProfit,
        wm_avg_age: totalAverageAge,
        wm_suga_sum: yoboTotalSugaSum,
        wm_pacient_count: uniquePatients.size
      }
    ];

    // 마감 데이터 저장 API 호출
    const response = await axios.post('/api/calc/wage-magam', {
      sisulCode: sisulCode,
      lebYm: lebYm,
      magamData: magamData
    }, { withCredentials: true });

    if (response.data.success) {
      store.commit('showSnackbar', { 
        text: '✅ 급여 설정이 확정되고 마감 처리되었습니다.', 
        color: 'success' 
      });
      emit('confirm');
    } else {
      store.commit('showSnackbar', { 
        text: '마감 처리에 실패했습니다: ' + (response.data.message || '알 수 없는 오류'), 
        color: 'error' 
      });
    }
  } catch (error: any) {
    console.error('마감 처리 오류:', error);
    store.commit('showSnackbar', { 
      text: '마감 처리 중 오류가 발생했습니다: ' + (error.response?.data?.message || error.message), 
      color: 'error' 
    });
  }
};

// 해제 버튼 클릭
const handleRelease = () => {
  showReleaseDialog.value = true;
};

const proceedRelease = async () => {
  showReleaseDialog.value = false;
  
  const user = store.state.user;
  if (!user || !user.m_sisul_code) {
    store.commit('showSnackbar', { text: '사용자 정보를 확인할 수 없습니다.', color: 'error' });
    return;
  }

  if (!tabSabokWageRef.value) {
    store.commit('showSnackbar', { text: '직원 데이터를 확인할 수 없습니다.', color: 'error' });
    return;
  }

  try {
    const searchParams = tabSabokWageRef.value.searchParams;
    
    // 마감 해제 API 호출
    const response = await axios.put('/api/calc/wage-magam/release', {
      sisulCode: user.m_sisul_code,
      lebYm: searchParams.lebYm
    }, { withCredentials: true });

    if (response.data.success) {
      store.commit('showSnackbar', { 
        text: '✅ 급여 설정 확정이 해제되었습니다.', 
        color: 'success' 
      });
      emit('release');
    } else {
      store.commit('showSnackbar', { 
        text: '확정 해제에 실패했습니다.', 
        color: 'error' 
      });
    }
  } catch (error: any) {
    console.error('확정 해제 오류:', error);
    store.commit('showSnackbar', { 
      text: '확정 해제 중 오류가 발생했습니다: ' + (error.response?.data?.message || error.message), 
      color: 'error' 
    });
  }
};

onMounted(async () => {
  // 초기 렌더 직후 데이터 기준으로 버튼 활성화 여부 재계산
  await nextTick();
  dataUpdateTrigger.value++;
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "32",
          color: "#1e3a8a"
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("mdi-account-tie", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "panel-title-section" }, [
        _createElementVNode("h2", { class: "panel-title" }, "사회복지사/센터장 급여 설정하기")
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        (isConfirmed.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn-header-action",
              onClick: handleRelease,
              disabled: isConfirming.value
            }, [
              (isConfirming.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "16",
                    width: "2",
                    color: "#f59e0b",
                    class: "mr-1"
                  }))
                : (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    size: "18"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("mdi-lock-open-variant", -1)
                    ]))]),
                    _: 1
                  })),
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "확정 해제", -1))
            ], 8, _hoisted_5))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn-header-action primary confirm-emphasis",
              onClick: handleConfirm,
              disabled: !stepCompleted.value || isConfirming.value
            }, [
              (isConfirming.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "16",
                    width: "2",
                    color: "#fff",
                    class: "mr-1"
                  }))
                : (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    size: "18"
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("mdi-lock-check", -1)
                    ]))]),
                    _: 1
                  })),
              _cache[8] || (_cache[8] = _createElementVNode("span", null, "급여 설정 확정하기", -1))
            ], 8, _hoisted_6))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (isConfirmed.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "#f59e0b"
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("mdi-lock", -1)
              ]))]),
              _: 1
            }),
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "notice-text" }, [
              _createTextVNode(" 급여 설정이 "),
              _createElementVNode("strong", null, "확정"),
              _createTextVNode("되어 수정할 수 없습니다. 수정하려면 상단의 "),
              _createElementVNode("strong", null, "확정 해제"),
              _createTextVNode(" 버튼을 눌러주세요. ")
            ], -1)),
            _createElementVNode("button", {
              class: "btn-release-inline",
              onClick: handleRelease,
              disabled: isConfirming.value
            }, [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("mdi-lock-open-variant", -1)
                ]))]),
                _: 1
              }),
              _cache[12] || (_cache[12] = _createTextVNode(" 확정 해제 ", -1))
            ], 8, _hoisted_9)
          ]))
        : _createCommentVNode("", true),
      _createVNode(TabSabokWage, {
        "is-magam": isConfirmed.value,
        ref_key: "tabSabokWageRef",
        ref: tabSabokWageRef
      }, null, 8, ["is-magam"])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showConfirmDialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showConfirmDialog).value = $event)),
      "max-width": "440px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "confirm-dialog" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "#10b981"
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("mdi-lock-check", -1)
                ]))]),
                _: 1
              }),
              _cache[15] || (_cache[15] = _createElementVNode("h3", null, "급여 설정 확정", -1))
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "confirm-dialog-body" }, [
              _createElementVNode("p", null, "사회복지사/센터장 급여 설정을 확정하시겠습니까?"),
              _createElementVNode("p", null, "확정 후에는 급여 설정을 수정할 수 없습니다.")
            ], -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn-cancel",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmDialog.value = false))
              }, "취소"),
              _createElementVNode("button", {
                class: "btn-confirm",
                onClick: proceedConfirm
              }, "확정")
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showReleaseDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showReleaseDialog).value = $event)),
      "max-width": "440px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "confirm-dialog" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "#f59e0b"
              }, {
                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                  _createTextVNode("mdi-alert-circle", -1)
                ]))]),
                _: 1
              }),
              _cache[18] || (_cache[18] = _createElementVNode("h3", null, "확정 해제", -1))
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "confirm-dialog-body" }, [
              _createElementVNode("p", null, "급여 설정 확정을 해제하시겠습니까?"),
              _createElementVNode("p", null, "해제 후에는 다시 수정이 가능합니다.")
            ], -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "btn-cancel",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showReleaseDialog.value = false))
              }, "취소"),
              _createElementVNode("button", {
                class: "btn-confirm warning",
                onClick: proceedRelease
              }, "해제")
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})